module.exports = {
  CREATE_REQUEST: 'create_service_request',
  LIST_REQUEST: 'list_service_request',
  GET_REQUEST_STAT: 'get_my_request_status',
};
